import React, { useState } from "react";
import api from "../../util/panelApi";
import { PageHead, img } from "./kit";

const KINDS = [
  ["wealth", "Varlık seviyesi", "Harcamaya göre (rozet profilde görünür)"],
  ["charm", "Cazibe seviyesi", "Aldığı hediyeye göre"],
  ["activity", "Aktivite seviyesi", "Odada kalma, mikrofon, sohbet"],
];

const Levels = () => {
  const [q, setQ] = useState("");
  const [data, setData] = useState(null);
  const [form, setForm] = useState({});
  const [msg, setMsg] = useState("");

  const find = async (e) => {
    e?.preventDefault();
    setMsg("");
    const r = await api.levelFind(q.trim());
    if (r?.status) {
      setData(r);
      setForm(r.levels);
    } else {
      setData(null);
      setMsg(r?.message || "Bulunamadı");
    }
  };

  const save = async () => {
    const body = {};
    KINDS.forEach(([k]) => (body[k] = Math.max(1, Math.min(800, parseInt(form[k]) || 1))));
    const r = await api.levelSet(data.account._id, body);
    setMsg(r?.message || "Kaydedilemedi");
    if (r?.status) find();
  };

  return (
    <>
      <PageHead title="Seviye Yönetimi" sub="Başka uygulamadan gelen yayıncı veya kullanıcıların seviyesini elle ayarla. Her değişiklik işlem günlüğüne yazılır." />
      <div className="card">
        <div className="card-body">
          <form className="d-flex" style={{ gap: 8 }} onSubmit={find}>
            <input className="form-control" placeholder="Kullanıcı ID (ör. 1000)" value={q} onChange={(e) => setQ(e.target.value)} />
            <button className="btn btn-primary" type="submit">Bul</button>
          </form>
          {msg && <div style={{ marginTop: 10, fontSize: 13, color: "#64748B" }}>{msg}</div>}
        </div>
      </div>
      {data && (
        <div className="card">
          <div className="card-body">
            <div className="d-flex align-items-center" style={{ gap: 10, marginBottom: 14 }}>
              {data.account.image && <img className="table_image" src={img(data.account.image)} alt="" />}
              <div>
                <b>{data.account.name}</b>
                <div style={{ fontSize: 12, color: "#64748B" }}>ID: {data.account.uniqueID}</div>
              </div>
            </div>
            {KINDS.map(([k, label, hint]) => (
              <div key={k} className="d-flex justify-content-between align-items-center" style={{ padding: "10px 0", borderBottom: "1px solid #F1F5F9", gap: 12 }}>
                <div>
                  <b>{label}</b>
                  <div style={{ fontSize: 12, color: "#64748B" }}>
                    {hint} · şu an LV{data.levels[k]}
                  </div>
                </div>
                <input className="form-control" style={{ width: 90 }} type="number" min="1" max="800" value={form[k] ?? 1} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
              </div>
            ))}
            <button className="btn btn-primary" style={{ marginTop: 14 }} onClick={save}>Seviyeleri kaydet</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Levels;
